import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import backgroundImage from '../homepage_1.png';

const theme = createTheme({
  palette: {
    mode: 'dark',
  },
});

const StyledHero = styled(Box)({
  backgroundImage: `url(${backgroundImage})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
});

const StyledHeroText = styled(Typography)({
  color: '#fff',
  fontWeight: 600,
  textAlign: 'right',
  textShadow: '0 0 10px #000',
  paddingTop: '6rem',
});

export default function HomePage() {
  return (
    <ThemeProvider theme={theme}>
      <StyledHero>
        <Container maxWidth="md">
          <StyledHeroText variant="h5">Move over Shiba Inu, there's a new doge in town: AI Samoyed. The latest meme-inspired cryptocurrency to hit the market is gearing up to take the Arbitrum network by storm and become the king of all meme coins.</StyledHeroText>
        </Container>
      </StyledHero>
      {/* Add more sections as needed */}
    </ThemeProvider>
  );
}